import React, { useState, useEffect } from 'react';
import { Image, Spin } from 'antd';
import StorefrontIcon from './StorefrontIcon.js';
import { getImageUrl } from '../SafeImage';

/**
 * Table image thumbnail specifically for Shops.
 * Uses the StorefrontIcon as the fallback when no shop image exists.
 * Usage: <ShopTableImage src={record.imageUrl} alt="shop" />
 */
const ShopTableImage = ({ src, alt = '', size = 48, radius = 8 }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [src]);

    const finalSrc = getImageUrl(src);

    if (!finalSrc || hasError) {
        return (
            <div
                style={{
                    width: size,
                    height: size,
                    minWidth: size,
                    borderRadius: radius,
                    background: 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)',
                    border: '1px solid #99f6e4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.04)'
                }}
            >
                <StorefrontIcon size={Math.round(size * 0.7)} />
            </div>
        );
    }

    return (
        <Image
            src={finalSrc}
            alt={alt}
            width={size}
            height={size}
            loading="lazy"
            placeholder={
                <div style={{
                    width: size,
                    height: size,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f8fafc',
                    borderRadius: radius,
                    border: '1px solid #e2e8f0'
                }}>
                    <Spin size="small" />
                </div>
            }
            style={{
                minWidth: size,
                borderRadius: radius,
                border: '1px solid #e2e8f0',
                display: 'block',
                objectFit: 'cover'
            }}
            preview={true}
            onError={() => setHasError(true)}
        />
    );
};

export default ShopTableImage;
